import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../../auth/UseUser';
import { ReactComponent as ShowPasswordIcon } from '../../assets/svg/ShowPasswordIcon.svg';
import { ReactComponent as HidePasswordIcon } from '../../assets/svg/HidePasswordIcon.svg';
import { ReactComponent as ChevronLeft } from '../../assets/svg/ChevronLeft.svg';
import { ReactComponent as ConfirmIcon } from '../../assets/svg/ConfirmIcon.svg';
import { ReactComponent as CheckSolid } from '../../assets/svg/CheckSolid.svg';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { notif } from '../utils/util';
import { changePassword, resetPassword } from '../../server/server';
import Loading from '../../utils/Loading';

type Inputs = {
	token: any;
	email: any;
	password: string;
	repeatPassword: string;
};

function ResetPassword({ ...props }) {
	const useQuery = () => {
		return new URLSearchParams(useLocation().search);
	};
	let query1 = useQuery();
	const navigate = useNavigate();
	const { user, setUser } = useUser();
	const [showPassword, setShowPassword] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setValue('email', query1.get('email'), { shouldValidate: true });
		setValue('token', query1.get('token'), { shouldValidate: true });
	}, []);

	const {
		register,
		handleSubmit,
		watch,
		getValues,
		setValue,
		trigger,
		formState: { errors, isValid },
	} = useForm<Inputs>({
		defaultValues: {
			token: '',
			email: '',
			password: '',
			repeatPassword: '',
		},
	});

	const onSubmit: SubmitHandler<Inputs> = async () => {
		console.log('change password data ', getValues('password'));
		let path = window.location.href;
		console.log('path ', path.includes('change-password'));
		if (path.includes('change-password')) {
			changePass();
		} else if (path.includes('resetPassword')) resetPass();
	};
	const resetPass = async () => {
		setLoading(true);
		const response = await resetPassword({
			token: getValues('token'),
			email: getValues('email'),
			password: getValues('password'),
		});
		if (response.status === 201) {
			notif('Nova lozinka je sačuvana');
			navigate('/login');
		} else {
			console.log('reset pass error ', response.data);
			notif('Došlo je do greške kod resetovanja lozinke');
		}
		setLoading(false);
	};
	const changePass = async () => {
		setLoading(true);
		const response = await changePassword(getValues('password'));
		if (response.status === 201) {
			notif('Lozinka je sačuvana');
			navigate('/login');
		} else {
			console.log('reset pass error ', response.data);
			notif('Došlo je do greške kod promene lozinke ');
		}
		setLoading(false);
	};

	const toggleShowPassword = () => {
		setShowPassword((prev) => !prev);
	};

	return (
		<div className='w-full h-screen overflow-auto bg-white orange-tiny-scroll md:orange-small-scroll pb-3'>
			<div className=' flex flex-col max-w-[430px] w-full px-3 m-auto '>
				<p className='text-[32px] leading-[44px] text-black700  font-bold mt-10 '>Promena lozinke</p>
				<p className='text-[16px] leading-5 text-black700 font-medium mt-[12px] mb-[32px] '>
					Poštovani, kako bi ste izmenili lozinku unesite novu lozinku 2 puta i portvdite klikom na "Promeni lozinku".
				</p>
				<form className='flex flex-col items-center w-full ' onSubmit={handleSubmit(onSubmit)} autoComplete='off'>
					<div className='flex flex-col w-full'>
						<label className='text-[16px] leading-5 text-black700 font-bold  '>Nova lozinka</label>
						<div className=' border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center '>
							<input
								className='text-[16px] leading-[22px] text-black700  w-full outline-none  placeholder:text-black200 '
								placeholder='Lozinka'
								type={showPassword ? 'text' : 'password'}
								{...register('password', {
									required: true,
									pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,}$/,
								})}
								autoComplete='off'
								onChange={(e) => {
									setValue('password', e.target.value.toString(), { shouldValidate: true });
									if (getValues('repeatPassword') !== '') trigger('repeatPassword');
								}}
							/>
							<div className='cursor-pointer' onClick={toggleShowPassword}>
								{!showPassword ? <ShowPasswordIcon /> : <HidePasswordIcon width={22} height={18} />}
							</div>
						</div>
						<span className='text-redError text-[12px] leading-5 min-h-[20px] '>
							{errors.password?.type === 'required' ? 'Obavezno popunite ovo polje!' : ''}
							{errors.password?.type === 'pattern' ? 'Šifra treba da ima najmanje 8 karaktera, jedno veliko slovo i jedan broj' : ''}
						</span>
						<div className='flex flex-row items-center h-8'>
							<p className='w-[200px] text-[16px] leading-5 text-greyMedium '>Jedno veliko slovo</p>
							{/[A-Z]/.test(watch('password')) && <CheckSolid />}
						</div>
						<div className='flex flex-row items-center h-8'>
							<p className='w-[200px] text-[16px] leading-5 text-greyMedium '>Jedno malo slovo</p>
							{/[a-z]/.test(watch('password')) && <CheckSolid />}
						</div>
						<div className='flex flex-row items-center h-8'>
							<p className='w-[200px] text-[16px] leading-5 text-greyMedium '>Jedan broj</p>
							{/[0-9]/.test(watch('password')) && <CheckSolid />}
						</div>
						<div className='flex flex-row items-center h-8'>
							<p className='w-[200px] text-[16px] leading-5 text-greyMedium '>Najmanje 8 karaktera</p>
							{watch('password').length > 7 && <CheckSolid />}
						</div>
					</div>
					<div className='flex flex-col w-full mt-5'>
						<label className='text-[16px] leading-5 text-black700 font-bold  '>Ponovljena nova lozinka</label>
						<div className=' border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center '>
							<input
								className='text-[16px] leading-[22px] text-black700  w-full outline-none  placeholder:text-black200 '
								placeholder='Ponovljena lozinka'
								type={showPassword ? 'text' : 'password'}
								{...register('repeatPassword', {
									validate: {
										obavezno: (value) => value.length > 0,
										corect: (val: string) => getValues('password') === val,
									},
								})}
								autoComplete='off'
							/>
							<div className='cursor-pointer' onClick={toggleShowPassword}>
								{!showPassword ? <ShowPasswordIcon /> : <HidePasswordIcon width={22} height={18} />}
							</div>
						</div>
						<span className='text-redError text-[12px] leading-5 min-h-[20px] '>
							{errors.repeatPassword?.type === 'obavezno' ? 'Obavezno popunite ovo polje!' : ''}
							{errors.repeatPassword?.type === 'corect' ? 'Lozinke se ne slažu molim Vas proverite.' : ''}
						</span>
					</div>

					<p className='text-redError text-[12px] leading-5 h-5 '>{!!errorMessage ? errorMessage : ''}</p>
					<div className='w-full flex flex-row gap-4 mb-5'>
						<button
							className={`w-[40%] h-[48px] flex items-center justify-center gap-3 rounded-[4px]   text-[18px] text-black700 font-bold cursor-pointer`}
							disabled={loading}
							onClick={(e) => {
								e.preventDefault();
								navigate('/login');
							}}
						>
							<ChevronLeft />
							<p>Odustani</p>
						</button>

						<button
							type='submit'
							className={`w-[60%] h-[48px] flex items-center justify-center rounded-[4px]   bg-orange300 hover:bg-orange400  text-[18px] text-black700 font-bold cursor-pointer`}
							disabled={loading}
						>
							{loading ? (
								<Loading size={25} />
							) : (
								<div className='w-full flex flex-row items-center justify-center gap-3'>
									<ConfirmIcon />
									<p>Promeni lozinku</p>
								</div>
							)}
						</button>
					</div>
				</form>
			</div>
		</div>
	);
}

export default ResetPassword;
